import {
  CampaignOutlined,
  FitnessCenter,
  ForumOutlined,
  GroupsOutlined,
  LocalCafe,
} from "@mui/icons-material";

const ICONS = {
  break: LocalCafe,
  input: CampaignOutlined,
  work: GroupsOutlined,
  discussion: ForumOutlined,
  workout: FitnessCenter,
};

export function getCardTypeIcon(type) {
  return ICONS[type] || null;
}
